var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFountainofknowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.7 21.73S167.5 84.97 146.2 155.4c-12.2 40.4 24.2 109.5 44.1 142.9h45.4c19.9-39.4-1.5-84.4-23.1-109.4 0 0 58.6 37.5 65.2 68.3 2.5 11.6-6.4 30.2-12.4 41.1H310c21-16.7 48.3-43.1 45.1-65-6.4-44.4-72-56.5-82.2-100.2-12-51.29 48.8-111.37 48.8-111.37zM64 192.8c-12.8 0-23 10.2-23 23s10.2 23 23 23 23-10.2 23-23-10.2-23-23-23zm384 1c-12.8 0-23 10.2-23 23s10.2 23 23 23 23-10.2 23-23-10.2-23-23-23zm-393 62v200h18v-200c-2.9.6-5.9 1-9 1-3.1 0-6.1-.4-9-1zm384 1v200h18v-200c-2.9.6-5.9 1-9 1-3.1 0-6.1-.4-9-1zm-270 59.5v30h174v-30H169zm30.2 48l-28 126h169.6l-28-126H199.2zm16.1 36.8l17.4 4.4-13.2 52.8h73l-13.2-52.8 17.4-4.4 18.8 75.2h-119l18.8-75.2zM32 470.8v18h64v-18H32zm384 1v18h64v-18h-64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFountainofknowledge);
export default __webpack_public_path__ + "static/media/fountainofknowledge.64f5e1234bb4eccea10414864efe1ed5.svg";
export { ForwardRef as ReactComponent };